import Button from '@components/_Revamp/Button'
import { TitleAndDescription } from '@components/_Revamp/TitleAndDescription'
import { styled } from '@linaria/react'
import React, { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import DisconnectSvgSrc from '@assets/images/sl-disconnected.svg';
import { Helpers } from '@utils/helpers'
import { useAvivaSelector } from '@redux/hook'


const SomethingWrong = () => {
  const history = useHistory();
  const basicDetails = useAvivaSelector(state => state.mltcR3Step1.basicDetails);
  const isTokenSet = useAvivaSelector(state=>state.loading.isTokenRecieved)

  const backtoHome = () => {
    history.push('/mltc/lets-get-started');
  };

  const onBack = useCallback(() => {
    history.push('/mltc/lets-get-started');
  }, [history]);

  useEffect(()=>{
    if(!isTokenSet){
      return 
    }
    // if (!basicDetails ) {
    //   onBack();
    //   return;
    // }
    Helpers.clearCached();
  },[]);


  return (
    <Container>
      <ContainerWrapper margin={"150px auto 0 auto"}>
        <ImageContainer src={DisconnectSvgSrc}>
        </ImageContainer>
        <TitleAndDescription
            margin={"0 0 80px"}
            title="Oops, something went wrong!"
            description="Try reconnecting to your Wifi or internet again and reload the page."
            descriptionMaxWidth={343}
          />
          <Button label="Back to home" width="285px" onClick={backtoHome} />
      </ContainerWrapper>
    </Container>
  )
}

export default SomethingWrong

const Container = styled.div`
  position:relative;
  margin: 0 auto;
  flex-direction:column;
  display: flex;
  flex-wrap: wrap;
  @media screen and (min-width: 768px) {
    max-width: 588px;
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }
`;

const ImageContainer = styled.img`
  margin-bottom: 75px;
`

const ContainerWrapper = styled.div<ContainerWrapperProps>`
  max-width: 588px;
  margin: 150px auto 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
`;

export interface ContainerWrapperProps {
  margin?: string;
}
